import { AppDispatch } from "@/redux";

import { removeFromInbox, setLeavingInboxLead } from "./list.slice";

/**
 * How long the departing inbox card stays visible while fading. Slightly
 * longer than the card's CSS `duration-200` transition so the fade completes
 * before the row unmounts.
 */
export const LEAD_LEAVE_ANIMATION_MS = 250;

/**
 * Two-phase inbox removal for the undo-send commit: mark the lead as leaving
 * (the card fades via `leavingInboxLeadId`), then actually remove it — which
 * re-points `currentLeadIndex` at the next reply (auto-advance).
 */
export const removeLeadWithFade = (
	dispatch: AppDispatch,
	listPersonId: number,
	onRemoved?: () => void
): void => {
	dispatch(setLeavingInboxLead(listPersonId));

	window.setTimeout(() => {
		dispatch(removeFromInbox(listPersonId));
		onRemoved?.();
	}, LEAD_LEAVE_ANIMATION_MS);
};
